<template>
  <div>
    <div class="position-relative">
      <section class="section-shaped  my-0">
        <bubbles-background></bubbles-background>
        <div class="container container-lg pb-4 shape-container">
          <card shadow class="card-profile mt-4 border-0" no-body>
            <vertical-ptwist-modules></vertical-ptwist-modules>
            <card-header title="Top Posts" :icon="{prefix:'fas', iconName: 'chart-line'}"
                         :text="pageText"></card-header>
            <div class="px-4 pb-3">
              <div class="row">
                <div class="col-md-4 col-sm-12">
                  <daterange-picker alternative></daterange-picker>
                </div>
                <div class="col-md-4 col-sm-12">
                  <collections-select v-model="collection" alternative
                                      label="Collection"></collections-select>
                </div>
                <div class="col-md-4 col-sm-12">
                  <language-select alternative label="Language"></language-select>
                </div>
              </div>
              <div class="mb-3 row">
                <div class="col-md-4">
                  <small class="d-block text-uppercase font-weight-bold mb-3">Sort by</small>
                  <base-button tag="a"
                               class="mb-3 mb-sm-0"
                               size="sm"
                               type="button"
                               @click="changeBy('retweets')"
                               :class="[ by === 'retweets' ? 'bg-blue text-white' : 'bg-secondary text-black-50']"
                               :icon="{ prefix: 'fas', iconName: 'retweet'}">
                    Retweets
                  </base-button>
                  <base-button tag="a"
                               class="mb-3 mb-sm-0"
                               size="sm"
                               type="button"
                               @click="changeBy('favorites')"
                               :class="[ by === 'favorites' ? 'bg-danger text-white' : 'bg-secondary text-black-50']"
                               :icon="{ prefix: 'fas', iconName: 'star'}">
                    Favorites
                  </base-button>
                </div>
              </div>
              <ptwist-loading v-if="loading"></ptwist-loading>
              <server-error v-else-if="error"></server-error>
              <div v-else-if="topTweets">
                <top-tweets-masonry :collection="collection" v-if="topTweets.by_retweet_count.length > 0"
                                    :tweets="by === 'retweets' ? topTweets.by_retweet_count : topTweets.by_favorite_count"></top-tweets-masonry>
                <div v-else class="text-center mt-5 mb-10">
                                <span class="d-block text-warning generic-error-icon">
                                    <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'exclamation-triangle' }"/>
                                    </span>
                  <span class="generic-error-text">No data available based on these parameters</span>
                </div>
              </div>
              <no-data-error v-else></no-data-error>
            </div>

          </card>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

import { Bus } from '../bus'
import { getInfoText } from '../info'
import VerticalPtwistModules from '@/components/VerticalPtwistModules.vue'

export default {
  name: 'top-posts',
  components: {
    VerticalPtwistModules
  },
  data () {
    return {
      collection: 'plastic_pollution',
      language: 'en',
      loading: true,
      pageText: getInfoText('topPosts'),
      by: 'retweets',
      timestampFrom: null,
      timestampTo: null,
      topTweets: null,
      error: false
    }
  },
  methods: {
    async changeBy (by) {
      this.by = by
      this.loading = true
      await this.$nextTick()
      this.loading = false
    },
    updateTopTweets () {
      this.loading = true
      this.topTweets = null
      let payload = {
        data: {
          collection: this.collection,
          language: this.language,
          timestamp_from: this.timestampFrom,
          timestamp_to: this.timestampTo
        },
        endpoint: 'twitter/top-tweets'
      }
      this.$store
        .dispatch('api/get', payload)
        .then(response => {
          this.topTweets = response.data
        })
        .catch(error => {
          console.error(error)
          this.error = true
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    timestampFrom () {
      this.updateTopTweets()
    },
    collection () {
      this.updateTopTweets()
    },
    language () {
      this.updateTopTweets()
    }
  },
  created () {
    Bus.$on('new-language', function (newLanguage) {
      this.language = newLanguage
      Bus.$emit('new-collections', this.language)
    }.bind(this))
    Bus.$on('new-collection', function (newCollection) {
      this.collection = newCollection
    }.bind(this))
    Bus.$on('daterange-update', function (timestamps) {
      this.timestampFrom = timestamps.from
      this.timestampTo = timestamps.to
    }.bind(this))
  }

}
</script>
<style>
</style>
